export const APPROVAL_CHECK = 'APPROVAL_CHECK';

export const approval_check_types = {
    FETCH_REQUEST: `${APPROVAL_CHECK}_REQUEST`,
    FETCH_SUCCESS: `${APPROVAL_CHECK}_SUCCESS`,
    FETCH_FAILURE: `${APPROVAL_CHECK}_FAILURE`,
};


